// ----------------------------------------------------------------------
// <copyright file="Izenda.CustomURLBody.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * CustomURLBody Component
 */
!(function() {
  var React = require('react');
  var EventsUtils = require('EventUtils');
  var Validator = require('share/components/hoc/Izenda.Validator');
  var ValidatableInput = Validator()(require('share/components/controls/Izenda.Input'));
  var customURLConstants = require('logic/data/Izenda.PropertiesBuilderConstants').CUSTOM_URL;
  var subReportConstant = require('logic/data/Izenda.PropertiesBuilderConstants').SUB_REPORT;
  var messages = require('logic/data/Izenda.PropertiesBuilderConstants').MESSAGE;
  var ViewSetting = require('./Izenda.ViewSetting');
  var localizer = require('share/localization/Izenda.Localizer');
  const { isNil, find, map, uniqueId } = require('lodash/fp');
  var CustomURLBody = React.createClass({
    getDefaultProps: function() {
      return {
        value: {
          url: '',
          option: customURLConstants.DEFAULT_VALUE
        }
      };
    },

    getInitialState: function() {
      var value = this.props.value;
      var selectedIcon = value.selectedIconValue;
      if (!selectedIcon || isNil(selectedIcon.icon) || isNil(selectedIcon.value)) {
        selectedIcon = {
          icon: subReportConstant.DEFAULT_ICON.icon,
          value: subReportConstant.DEFAULT_ICON.value
        };
      }

      return {
        url: value.url,
        option: value.option,
        viewSettingByLink: isNil(value.viewSettingByLink)
          ? true // Default value
          : value.viewSettingByLink,
        selectedIconValue: selectedIcon
      };
    },

    beforeClosing: function(valManager, type) {
      var props = this.props;

      if (
        type === 'accept' &&
        props.checkUniqLinkOption &&
        !props.checkUniqLinkOption(this.state, customURLConstants.NAME)
      ) {
        return props.confirmMessage('error', messages.DUPLICATE_VIEW_SETTING);
      } else {
        return Promise.resolve(true);
      }
    },

    getValue: function() {
      return this.state;
    },

    updateViewSettingByLink: function() {
      this.setState({
        viewSettingByLink: !this.state.viewSettingByLink
      });
    },

    updateSelectedViewSettingIcon: function(value) {
      var selectedIcon = find({ value: value }, subReportConstant.ICON_TYPES);
      if (selectedIcon) {
        this.setState({
          selectedIconValue: {
            icon: selectedIcon.icon,
            value: selectedIcon.value
          }
        });
      }
    },

    renderRadioSelection: function() {
      var notifyChange = EventsUtils.notifyChange;

      var handelChangeOption = function(value) {
        this.setState({
          option: value
        });
      }.bind(this);

      var result = map(
        function(option) {
          return (
            <div key={uniqueId('url_')} className="radio">
              <label>
                <input
                  onChange={notifyChange(handelChangeOption, EventsUtils.INPUT)}
                  type="radio"
                  name="optradio"
                  value={option}
                  checked={option === this.state.option}
                />
                {localizer.getText(String.format('PROPERTIES_BUILDER_CONSTANTS_CUSTOM_URL_OPTIONS_{0}', option))}
              </label>
            </div>
          );
        }.bind(this),
        customURLConstants.OPTIONS
      );

      return result;
    },

    renderViewSetting: function() {
      var state = this.state;

      return (
        this.props.hiddenIconSettingSubReport === false && (
          <ViewSetting
            viewSettingByLink={state.viewSettingByLink}
            selectedIconValue={state.selectedIconValue}
            updateSelectedViewSettingIcon={this.updateSelectedViewSettingIcon}
            updateViewSettingByLink={this.updateViewSettingByLink}
          />
        )
      );
    },

    render: function() {
      var notifyChange = EventsUtils.notifyChange;

      var handelChangeUrl = function(value) {
        this.setState({
          url: value
        });
      }.bind(this);

      return (
        <div>
          <label>{customURLConstants.CONTENT_DESCRIPTION}</label>
          <ValidatableInput
            className="form-control u_resizeVertical"
            onChange={notifyChange(handelChangeUrl, EventsUtils.INPUT)}
            value={this.state.url}
            validations={customURLConstants.CONSTRAINTS.URL}
            field="url"
          />
          {this.renderRadioSelection()}
          {this.renderViewSetting()}
        </div>
      );
    }
  });

  module.exports = CustomURLBody;
})();



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/PropertiesBuilder/Izenda.CustomURLBody.jsx